import React, { useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import { useSpring, animated, easings } from '@react-spring/web';
import { ReactSVG } from 'react-svg';
import logo from '../../assets/logo.svg';
import sunRays from '../../assets/backgrounds/sun_rays.svg';
import '../Slides.scss';
import './OtherSlides.scss';

const LoadingSlide = ({color}) => {
 
  const [fadeInDone, setFadeInDone] = useState(false);
  const [messageDisplay, setMessageDisplay] = useState(0);

  const messages = ['Plugging in the amps...', 'Tuning up the instruments...', 'Getting ready to rock...']

  useEffect(() => {
    const timeout = setInterval(() => {
      const next = (messageDisplay + 1) <= (messages.length - 1) ? messageDisplay + 1 : 0;
      setMessageDisplay(next)
    }, 2500);

    return () => clearInterval(timeout);
  }, [messages, messageDisplay])



  const logoSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    delay: 200,
  });


  const subTitleSpring = useSpring({
    from: { opacity: 0, transform: 'translateX(100px)' },
    to: { opacity: 1, transform: 'translateX(0px)' },
    delay: 400,
    config: {
      tension: 180,  
      friction: 12,  
    },
  });

  const sunSpring = useSpring({
    from: { opacity: 0, transform: 'translateY(100vh)' },
    to: { opacity: 1, transform: 'translateY(0px)' },
    delay: 600,
  });

  const sunRaysFadeInSpring = useSpring({
    from: { opacity: 0 },
    to: { opacity: 1 },
    config: { duration: 1000 },
    delay: 800,
    onRest: () => setFadeInDone(true),
  });

  const sunRaysScaleSpring = useSpring({
    from: { scale: 1 },
    to: { scale: 1.1 },
    loop: fadeInDone ? { reverse: true } : false,
    config: { duration: 1500, easing: easings.easeInOutSine },
  });

  const sunRaysSpring = {
    ...sunRaysFadeInSpring,
    ...sunRaysScaleSpring,
  };

  return (
    <div className='Slide__loading' style={{backgroundColor: color}}>
      <animated.div className='Slide__loading__logo' style={logoSpring}>
        <ReactSVG src={logo} />
      </animated.div>
      <animated.h3 className='Slide__loading__subTitle' style={subTitleSpring}>{messages[messageDisplay]}</animated.h3>
      <animated.div className='Slide__loading__sun' style={sunSpring} />
      <animated.div className='Slide__loading__sunRays' style={sunRaysSpring}>
        <ReactSVG src={sunRays} />
      </animated.div>
    </div>
  );
};

export default LoadingSlide;


LoadingSlide.propTypes = {
  color: PropTypes.string.isRequired
};
